export default __webpack_public_path__ + "static/QuickStart@2x-f3dc31edc2b1070fbef4e07b77a8052a.jpg";